'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { LuArrowDownUp } from 'react-icons/lu';

type CategorySortProps = {
  className?: string;
};

export function CategorySort(props: CategorySortProps) {
  const { className } = props;
  const { t } = useTranslations();

  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-center gap-4 md:w-fit',
        'ea-category-sort',
        className,
      )}
    >
      <div className={cn('w-full md:w-fit', 'ea-category-sort__select-wrapper')}>
        <Select value={selectedValue} onValueChange={e => onSortChange(e)}>
          <SelectTrigger
            aria-label={`${t('text341')}: ${t(VALUES.find(item => String(item.value) === selectedValue)?.label ?? 'text341')}`}
            // placeholder={`${t('text341')}..`}
            innerTriggerClassName="px-3 gap-2 items-center justify-center"
            className={cn(
              'h-[50px] w-full gap-2 rounded-[12px] border-none bg-[#E4F2E7] text-sm font-medium text-primary md:w-fit lg:text-base',
              'ea-category-sort__select-trigger',
            )}
            expandIcon={null}
          >
            <LuArrowDownUp size={20} className="text-primary" />
            <SelectValue
              placeholder={`${t('text341')}..`}
              className={cn('', 'ea-category-sort__select-value')}
            />
          </SelectTrigger>
          <SelectContent
            sideOffset={2}
            className={cn('rounded-[20px] border  shadow-none', 'ea-category-sort__select-content')}
          >
            {VALUES?.map(o => (
              <SelectItem
                key={o.value}
                value={String(o.value)}
                className={cn('rounded-[16px]', 'ea-category-sort__select-item')}
              >
                {t(o.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default CategorySort;
